import { FormattedMessage } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
import { getMessageHyperlinkValue } from "@/templates/software/confluence/pricing/src/sections/expander-contents/message-hyperlink.tsx";
const Databases = () => {
    const localizedHref = useLocalizedHref("/software/confluence/databases");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.databases.content.body"
                    defaultMessage="Confluence databases are a central source of info that dramatically changes the way that teams can organize, reference, and display data in Confluence. <a>Learn more</a>."
                    values={{
                        ...DEFAULT_VALUES,
                        a: getMessageHyperlinkValue({
                            localizedHref,
                            "data-event-container": "ConfluencePricingPage",
                            "data-label-english": "Learn more",
                            "data-track-event":
                                "ConfluencePricingPageTeam24.databases"
                        })
                    }}
                />
            </p>
        </div>
    );
};
export default Databases;
